import React, { Component } from 'react';
import DateTimeField from 'react-bootstrap-datetimepicker';
import moment from 'moment';
import 'react-bootstrap-datetimepicker/css/bootstrap-datetimepicker.css';
import '../../../public/css/order.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { orderDate } from '../../dashboard/actions';
var locale = require('browser-locale')();

class RestaurantAvailableDates extends Component {
  constructor(props) {
    super(props);
    const dateTime = props.compareDay
      ? this.props.selectedDate || moment().format('x')
      : moment()
          .add(1, 'days')
          .format('x');
    this.state = {
      dateTime: dateTime === 'now' ? moment().format('x') : dateTime,
      format: 'x',
      mode: 'date',
      maxDays: this.props.nextDay
        ? Number(this.props.maxAdvanceDays) + 1
        : Number(this.props.maxAdvanceDays),
    };
  }
  minDate = () => {
    const { compareDay } = this.props;
    const minDate = compareDay ? 0 : 1;
    return moment().add(minDate, 'days');
  };
  maxDate = () => {
    const { maxDays } = this.state;
    return moment().add(maxDays, 'days');
  };
  componentDidMount() {
    const { actions, selectedDate } = this.props;
    const { dateTime } = this.state;
    if (selectedDate !== dateTime) {
      actions.orderDate(dateTime);
    }
  }
  handleChange(date) {
    this.props.changedDate();
    const currentDate = this.props.nextDay
      ? moment()
          .add(1, 'days')
          .format('x')
      : moment().format('x');
    const allowedTillDate = moment()
      .add(this.state.maxDays, 'days')
      .format('x');
    if (date >= Number(currentDate) && date <= Number(allowedTillDate)) {
      this.setState({
        dateTime: date,
      });

      if (
        moment(Number(date)).format('YYYY-MM-DD') !==
        moment(Number(this.props.selectedDate)).format('YYYY-MM-DD')
      ) {
        this.props.dateSelected(Number(date));
      }
    } else {
      this.setState({
        dateTime: currentDate,
      });

      if (
        moment(Number(currentDate)).format('YYYY-MM-DD') !==
        moment(Number(this.props.selectedDate)).format('YYYY-MM-DD')
      ) {
        this.props.dateSelected(Number(currentDate));
      }
    }
  }

  render() {
    const { format, mode } = this.state;
    let { dateTime } = this.state;
    const dateInput = new Intl.DateTimeFormat(locale)
      .format(dateTime)
      .toString();
    return (
      <div className="marginDatePicker">
        <DateTimeField
          dateTime={dateTime}
          format={format}
          inputFormat={dateInput}
          onChange={this.handleChange.bind(this)}
          mode={mode}
          minDate={this.minDate()}
          maxDate={this.maxDate()}
        />
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      orderDate,
    },
    dispatch
  ),
});
export default connect(
  null,
  mapDispatchToProps
)(RestaurantAvailableDates);



// WEBPACK FOOTER //
// ./src/views/checkout/components/RestaurantAvailableDates.jsx